// akhila 1/12/2022 2692790263 added BasicInfo in workqueue
// akhila 1/12/2022 2692790263 added new payload changes
// kavya9reddy 12/1/2022 2692790263 added validation in basic info
// Sohel 12/04/2022 2692790263 Added alertPopup
// akhila 12/07/2022 2692790263 added default value for createdFor
// akhila 12/08/2022 2692790263 changed labels workqueue to Work Queue
// Sohel 12/13/2022 2692790263 conditionally hide Save Button
// Lalitha 12/23/2022 2692790263 Added reusable Validation in code
// Raghu 12/29/2022 2692790263 Button Spacing Fixes
// kavyareddy 01/05/2023 2692790263 Fixed label issues
// //Sohel 02/13/2023 2692790263 WorkQueue validation Changes
// Ravi 02/20/2023 2692790263 fixed validation issue in code
// Ravi 02/22/2023 2692790263 Added Client Code Field
// Rohini 02/28/2023 2692790263 removed the class name
// suresh peddavoora 03/01/2023 2692790263 new ui changes
// suresh peddavoora 03/03/2023 2692790263 Tables and fields alignments
// suresh peddavoora 03/06/2023 2692790263 New UI changes for textfields
// sohel 03/06/2023 2692790263 Added validation message for existing value
// Raghu 03/09/2023 2692790263 added new new classname for primary account field
// Prakash 11-04-23 2692790263 fixed input filed issue in Work Queue Setup.
// Ravi 04/19/2023 2692790263  modified client code dropDownData data
// Ravi 05/08/2023 2692790263  fixed accept only upper Case in WorkQueue Code
// Phanee 06/02/2023 2692790263 Work Queue Duplicate Render Issue
// Ravi 07/19/2023 2692790263  added fixedlength field in Basic Info
// Ravi 06/24/2023 2692790263  removed type from basicInfo get API
// Ravi 07/24/2023 2692790263  removed upperCase from workQueue Name
// Ravi 07/26/2023 2692790263  removed multiple hypen validation from workQueue Name
import {
  Button,
  FormHelperText,
  MenuItem,
  TextField,
  InputLabel,
  Select,
  FormControl,
  Checkbox,
  Grid,
  // Grid,
  // Checkbox,
} from '@material-ui/core';
// import Autocomplete from "@material-ui/lab/Autocomplete";
import {Formik} from 'formik';
import React, {useEffect, useRef, useState, useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import * as Yup from 'yup';
// import ReusableInputStyles from "./../../../components/InputStyles/index";
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {SuccessSnackbar, ErrorSnackbar} from '../../../../components/CustomSnackBar/index';
import PageLoader from '../../../../components/PageLoader/index';
import {
  getAllReportCreatedForData,
  resetReportFieldsData,
  setReduxState,
} from '../../../../redux/reducers/ReportMaster';
import {currsorCodeIssue} from '../../../../components/UpperCaseCode';
import {submissionStart} from '../../../../redux/reducers/CommonActions/commonActions';
import {
  fetchBasicInfo,
  getAllWqCodeData,
  postHeaderInfo,
  resetMessage,
} from '../../../../redux/reducers/WorkQueueSetup';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import {getOptions} from '../../../../util/GetDropDownOptions';
import {COMPANY_TYPE} from '../../../../constants/Lookup';
import {getCompanyCode} from '../../../../redux/reducers/LetterMaintainance/AddLetterData';
import {
  ResetUsersAndRoles as resetUsersAndRoles,
  reportMasterRoleNameByCompany,
  reportMasterUserNameByCompany,
} from '../../../../redux/reducers/BRE/AddReportMaster';
const WorkQueueBasicInfo = ({
  activeStep,
  handleBack,
  handleNext,
  handleDirty,
  roleAccess,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const {
    reportCreatedForData,
  } = useSelector(({reportMaster}) => reportMaster);
  const {wqCodeData, wqCode, basicInfoData, isLoading, successMsg, errorMsg, addHeaderStatus} =
    useSelector(({addWorkQueue}) => addWorkQueue);
  const {companyCodeData} = useSelector(({addLetterData}) => addLetterData);
  const [codePopover, setCodePopover] = useState(false);
  const [reportCodesData, setReportCodesData] = useState();
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {roleNameData, userNameData} = useSelector(({addReportMaster}) => addReportMaster);
  const saveRef = useRef();
  const codeRef = useRef();
  const {clientCodeDropdownData} = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const rolesData = roleNameData?.length > 0 ? roleNameData?.map((el) => el.roleName) : [];
  const checkReportCodeExist = (value) => {
    if (wqCodeData && wqCodeData?.length > 0 && value) {
      const ar = [];
      wqCodeData?.forEach((i) => {
        if (
          i?.workqueueName?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y' &&
          basicInfoData?.workqueueName?.toLowerCase()?.trim() !== value?.toLowerCase()?.trim()
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkReportCodeAlreadyExist = (value) => {
    if (wqCodeData && wqCodeData?.length > 0 && value) {
      const ar = [];
      wqCodeData?.forEach((i) => {
        if (
          i?.workqueueName?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N' &&
          basicInfoData?.workqueueName?.toLowerCase()?.trim() !== value?.toLowerCase()?.trim()
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const options = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const fixedLengthOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const dateStampOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const showDashboardOptions = [
    {key: 'N', value: 'No'},
    {key: 'showSplitScreen', value: 'Show Split Screen'},
    {key: 'dontShowSplitScreen', value: 'Don\'t Show Split Screen'},
  ];

  const getObject = (option, options) => {
    let obj = {};
    options &&
      options?.map((ele) => {
        if (option === ele.value || option === ele.key || option === ele.userName) {
          obj = ele;
        }
      });
    return obj;
  };

  const getWorkqueueCodesData = () => {
    if (wqCodeData && wqCodeData?.length > 0) {
      return wqCodeData?.filter(
        (i) => String(i?.workqueueName)?.startsWith(reportCodesData) && i?.isActive === 'Y',
      );
    } else {
      return [];
    }
  };

  const validationSchema = Yup.object().shape({
    workQueueCode: Yup.string()
      .required('Work Queue Name is required')
      .test('reportCode', 'Work Queue Name already in use', (value) => !checkReportCodeExist(value))
      .test(
        'reportCode',
        'Work Queue Name has already been used in the past',
        (value) => !checkReportCodeAlreadyExist(value),
      ),
    workQueueDescription: Yup.string().required('Work Queue Description is required'),
    companyCode: Yup.mixed().test('companyCode', 'Company code is required', (value, context) => {
      if (value?.length > 0 || value?.companyCode) {
        return true;
      } else {
        return false;
      }
    }),
    seedOnly: Yup.string().required('Primary Account is required').nullable(),
    dateStamp: Yup.object().nullable().required('Date Stamp require is required'),
  });
  const getClientCodes = (user, clientCodeData) => {
    return clientCodeData?.filter((i) => user?.includes(i?.clientNumber));
  };
  const user = JSON.parse(sessionStorage.getItem('userDetails'));
  const initialValues = {
    workQueueCode: basicInfoData?.workqueueName ? basicInfoData?.workqueueName : '',
    seedOnly: basicInfoData?.seedOnly ? basicInfoData?.seedOnly : 'Y',
    workQueueDescription: basicInfoData?.workqueueDescription ?
      basicInfoData?.workqueueDescription :
      '',
    createdFor: basicInfoData?.createdFor ?
      getObject(basicInfoData?.createdFor, reportCreatedForData) :
      {userName: user?.userName},
    user:
      basicInfoData?.clientCode?.length > 0 ?
        getClientCodes(basicInfoData?.clientCode, clientCodeDropdownData) :
        [],
    fixedLength: basicInfoData?.fixedLength ?
      getObject(basicInfoData?.fixedLength, fixedLengthOptions) :
      {key: 'N', value: 'No'},
    dateStamp: basicInfoData?.requireDateStamping ?
      getObject(basicInfoData?.requireDateStamping, dateStampOptions) :
      {key: 'N', value: 'No'},
    showDashboard: basicInfoData?.showDashboard ? basicInfoData?.showDashboard : 'N',
    companyCode: basicInfoData?.companyCode?.length > 0 ? basicInfoData?.companyCode.map((each) => ({value: each})) : [],
    roles: basicInfoData?.accessRoles ? basicInfoData?.accessRoles : [],
    users: basicInfoData?.accessUsers ? basicInfoData?.accessUsers?.map((each) => ({userLoginName: each})) : [],
  };
  const handleSubmit = (values) => {
    if (values) {
      dispatch(submissionStart());
      const data = {
        workqueueDescription: values?.workQueueDescription ? values?.workQueueDescription : '',
        workqueueId: basicInfoData?.workqueueId ? basicInfoData?.workqueueId : 0,
        accessRoles: values?.roles ? values?.roles : [],
        accessUsers: values?.users ? values?.users?.map((each) => each?.userLoginName) : [],
        showDashboard: values?.showDashboard ? values?.showDashboard : 'N',
        companyCode: values?.companyCode ? values?.companyCode.map((each) => each?.value) : [],
        seedOnly: values?.seedOnly ? values?.seedOnly : '',
        lastStep: saveRef.current ? 0 : 1,
        workqueueName: values?.workQueueCode ? values?.workQueueCode : '',
      };
      dispatch(postHeaderInfo(data));
      dispatch(setReduxState({property: 'initialSave', value: !data?.reportId}));
    }
  };

  useEffect(() => {
    if (addHeaderStatus === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
        !saveRef.current && handleNext();
      }, 1000);
    }
  }, [addHeaderStatus]);

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 500);
    }
  }, [errorMsg, successMsg]);

  useEffect(() => {
    if (wqCode) {
      dispatch(fetchBasicInfo(wqCode));
      dispatch(resetReportFieldsData());
    }
  }, [wqCode]);
  useEffect(() => {
    dispatch(getCompanyCode());
  }, []);

  useEffect(() => {
    dispatch(getAllWqCodeData());
    dispatch(getAllReportCreatedForData());
  }, []);
  useEffect(() => {
    if (basicInfoData?.companyCode?.length > 0) {
      dispatch(reportMasterRoleNameByCompany({companyCode: basicInfoData?.companyCode}));
      dispatch(reportMasterUserNameByCompany({companyCode: basicInfoData?.companyCode}));
    }
  }, [basicInfoData]);

  window.onclick = function() {
    setCodePopover(false);
  };
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="form-row global-field-textfields new-standard-textfields">
                <div
                  className={`col-sm-6 col-md-4 col-lg-4  col-xl-4 ${
                    errors?.workQueueCode?.length > 30 ? 'form-group-lg' : 'form-group'
                  }`}
                >
                  <TextField
                    placeholder="Enter Work Queue Name"
                    className={` ${classes.labelName}`}
                    margin="dense"
                    name="workQueueCode"
                    variant="outlined"
                    value={values?.workQueueCode}
                    label="Work Queue Name"
                    inputProps={{maxLength: 25}}
                    required
                    inputRef={codeRef}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      const value = currsorCodeIssue(codeRef);
                      setFieldValue('workQueueCode', value);
                      if (e.target.value) {
                        setCodePopover(true);
                        setReportCodesData(e.target.value);
                      } else if (e.target.value === '') {
                        setCodePopover(false);
                      }
                    }}
                    touched={touched.workQueueCode}
                    error={Boolean(errors.workQueueCode && touched.workQueueCode)}
                    fullWidth
                  />
                  <FormHelperText style={{color: 'red'}} variant="outlined">
                    {touched.workQueueCode && errors.workQueueCode}
                  </FormHelperText>
                  <div className="windowcode-popover Add-trigger-group-popover">
                    {codePopover &&
                      getWorkqueueCodesData()?.map((data, i) => (
                        <MenuItem key={i}>{data?.workqueueName}</MenuItem>
                      ))}
                  </div>
                </div>
                <div className="col-sm-6 col-md-8 col-lg-8 col-xl-8 form-group">
                  <TextField
                    // className={` ${classes.labelName} ${classes.inputLabel}`}
                    placeholder="Enter Work Queue Description"
                    className={` ${classes.labelName}`}
                    margin="dense"
                    name="workQueueDescription"
                    value={values.workQueueDescription}
                    variant="outlined"
                    label="Work Queue Description"
                    inputProps={{maxLength: 100}}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    touched={touched.workQueueDescription}
                    required
                    error={Boolean(errors.workQueueDescription && touched.workQueueDescription)}
                    fullWidth
                  />
                  <FormHelperText style={{color: 'red'}} variant="outlined">
                    {touched.workQueueDescription && errors.workQueueDescription}
                  </FormHelperText>
                </div>
                <Grid
                  item
                  xs={6}
                  md={6}
                  lg={4}
                  className={`col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group autocomplete-field ${
                    values?.companyCode?.length > 2 && `autocomplete-checkbox`
                  }`}
                >
                  <GuiAutoComplete
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    multiple
                    disableCloseOnSelect
                    limitTags={1}
                    id="companyCode"
                    size="small"
                    className={`${classes.labelName}`}
                    value={values?.companyCode}
                    options={getOptions(COMPANY_TYPE, companyCodeData)}
                    getOptionSelected={(option, value) => option?.value === value?.value}
                    getOptionLabel={(option) => {
                      return option?.value;
                    }}
                    onChange={(e, value) => {
                      setFieldValue('companyCode', value);
                      if (value?.length) {
                        dispatch(reportMasterRoleNameByCompany({companyCode: value?.map((el) => el?.value)}));
                        dispatch(reportMasterUserNameByCompany({companyCode: value?.map((el) => el?.value)}));
                      }
                      dispatch(resetUsersAndRoles());
                      setFieldValue('roles', []);
                      setFieldValue('users', []);
                    }}
                    onBlur={handleBlur}
                    renderOption={(option, {selected}) => (
                      <React.Fragment>
                        <Checkbox
                          icon={icon}
                          checkedIcon={<CheckBoxIcon fontSize="small" className="selectcheckBox" />}
                          checked={selected}
                          className={classes.checkBox}
                        />
                        {option.value ? option?.value : ''}
                      </React.Fragment>
                    )}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          className={`autocomplete-multiselect-label add-role-fields placeholder-filed`}
                          {...params}
                          variant="outlined"
                          margin="dense"
                          id="companyCode"
                          name="companyCode"
                          label="Company Code"
                          error={Boolean(touched.companyCode && errors.companyCode)}
                          placeholder="Select Company Code"
                          aria-label="form-label-4"
                        />
                      </div>
                    )}
                  />
                  <FormHelperText error variant="outlined">
                    {touched.companyCode && errors.companyCode}
                  </FormHelperText>
                </Grid>
                <div
                  className={`col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group autocomplete-field ${
                    values?.roles?.length > 2 && `autocomplete-checkbox`
                  }`}
                >
                  <FormControl margin="dense" variant="outlined" fullWidth>
                    <GuiAutoComplete
                      name={'roles'}
                      id={'roles'}
                      limitTags={1}
                      size="small"
                      classes={{
                        option: classes.option,
                        listbox: classes.listBox,
                      }}
                      disableCloseOnSelect
                      getOptionSelected={(option, value) => option === value}
                      value={values?.roles?.length > 0 ? values?.roles : []}
                      multiple
                      onChange={(e, value) => {
                        if (value?.length > 0) {
                          // setWorkQueueError(false);
                        }
                        handleChange(e);
                        setFieldValue('roles', value);
                      }}
                      disabled={values?.users?.length || !values?.companyCode?.length}
                      options={rolesData}
                      autoHighlight
                      renderOption={(option, {selected}) => {
                        return (
                          <React.Fragment>
                            <>
                              <Checkbox
                                icon={icon}
                                checkedIcon={
                                  <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                                }
                                checked={selected}
                                className={classes.checkBox}
                              />
                            </>
                            {option}
                          </React.Fragment>
                        );
                      }}
                      getOptionLabel={(option) => {
                        return option;
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            variant="outlined"
                            className={`autocomplete-multiselect-label ${classes.labelName}`}
                            margin="dense"
                            touched={touched}
                            error={touched?.roles && errors?.roles}
                            // InputLabelProps={{ shrink: true }}
                            label={'Work Queue Roles'}
                            placeholder={`Select Work Queue Roles`}
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off', // disable autocomplete and autofill
                            }}
                          />
                        </div>
                      )}
                    />
                  </FormControl>
                  <FormHelperText variant="outlined">
                    {touched?.roles && errors?.roles ? errors.roles : ''}
                  </FormHelperText>
                </div>
                <div
                  className={`col-sm-6 col-md-6 col-lg-4 form-group autocomplete-field ${
                    values?.users?.length > 2 && `autocomplete-checkbox`
                  }`}
                >
                  <FormControl margin="dense" variant="outlined" fullWidth>
                    <GuiAutoComplete
                      name={'users'}
                      id={'users'}
                      size="small"
                      limitTags={1}
                      classes={{
                        option: classes.option,
                        listbox: classes.listBox,
                      }}
                      disableCloseOnSelect
                      getOptionSelected={(option, value) => option?.userLoginName === value?.userLoginName}
                      value={values?.users?.length > 0 ? values?.users : []}
                      multiple
                      onChange={(e, value) => {
                        // if (value?.length > 0) {
                        //   setWorkQueueError(false);
                        // }
                        handleChange(e);
                        setFieldValue('users', value);
                      }}
                      disabled={values?.roles?.length || !values?.companyCode?.length}
                      options={userNameData}
                      autoHighlight
                      renderOption={(option, {selected}) => {
                        return (
                          <React.Fragment>
                            <>
                              <Checkbox
                                icon={icon}
                                checkedIcon={
                                  <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                                }
                                checked={selected}
                                className={classes.checkBox}
                              />
                            </>
                            {option?.userName + ' - ' + option?.userLoginName}
                          </React.Fragment>
                        );
                      }}
                      getOptionLabel={(option) => {
                        return option?.userLoginName;
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            variant="outlined"
                            className={`autocomplete-multiselect-label ${classes.labelName}`}
                            margin="dense"
                            // touched={touched}
                            // error={touched?.user && errors?.user}
                            // InputLabelProps={{ shrink: true }}
                            label={'Work Queue Users'}
                            placeholder={`Select Work Queue Users`}
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off', // disable autocomplete and autofill
                            }}
                          />
                        </div>
                      )}
                    />
                  </FormControl>
                </div>
                <div className={`col-sm-6 col-md-6 col-lg-4 form-group ${classes.selectField}`}>
                  <FormControl margin="dense" variant="outlined" fullWidth className="form-group">
                    <InputLabel id="demo-simple-select-label" required>
                      Show Work Queue List
                    </InputLabel>
                    <Select
                      fullWidth
                      label="Show Work Queue List"
                      labelId="demo-simple-select-label"
                      name="showDashboard"
                      className={`select-gender ${classes.labelName}`}
                      value={values?.showDashboard ?? 'N'}
                      onChange={handleChange}
                      placeholder="Select Work Queue List"
                      onBlur={handleBlur}
                      touched={touched?.showDashboard}
                      error={Boolean(touched?.showDashboard && errors?.showDashboard)}
                    >
                      {showDashboardOptions.map((option) => {
                        return (
                          <MenuItem value={option.key} key={option.key}>
                            {option.value}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormHelperText>
                    {touched?.showDashboard && errors.showDashboard && errors.showDashboard}
                  </FormHelperText>
                </div>
                <div
                  className={`form-group col-sm-3 col-md-4 col-lg-4 col-xl-4 ${classes.selectField}`}
                >
                  <FormControl margin="dense" variant="outlined" fullWidth className="form-group">
                    <InputLabel id="demo-simple-select-label">Primary Accounts Only</InputLabel>
                    <Select
                      fullWidth
                      name="seedOnly"
                      className={` ${classes.labelName}`}
                      labelId="demo-simple-select-label"
                      label="Primary Accounts Only"
                      value={values?.seedOnly ?? 'Y'}
                      onChange={handleChange}
                      placeholder="Select seedOnly"
                      onBlur={handleBlur}
                      touched={touched?.seedOnly}
                      error={Boolean(touched?.seedOnly && errors?.seedOnly)}
                    >
                      {options.map((option) => {
                        return (
                          <MenuItem
                            className={` ${classes.labelName}`}
                            value={option.key}
                            key={option.key}
                          >
                            {option.value}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormHelperText>
                    {touched?.seedOnly && errors.seedOnly && errors.seedOnly}
                  </FormHelperText>
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-center new-standard-textfields disabled-button">
                <Button
                  variant="outlined"
                  className={`reset-btn mr-1 ${classes.buttonRoot}`}
                  disabled={activeStep === 0}
                  onClick={handleBack}
                >
                  Back
                </Button>
                {/* {isDraftReport === "N" && ( */}
                <Button
                  variant="outlined"
                  type="submit"
                  className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                  disabled={roleAccess || enabledSubmission}
                  onClick={() => {
                    saveRef.current = true;
                    handleDirty(false, 'fixed');
                  }}
                >
                  Save
                </Button>
                {/* )} */}
                <Button
                  variant="outlined"
                  type="submit"
                  className={`search-btn ml-1 ${classes.buttonRoot}`}
                  disabled={roleAccess || enabledSubmission}
                  onClick={() => {
                    saveRef.current = false;
                  }}
                >
                  Save & Next
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default WorkQueueBasicInfo;
